export default __webpack_public_path__ + "static/media/Easee-Appointment-Tracker-2-img-1.a9e9125f.jpg";